import React, { useState, useEffect } from "react";
import "./index.scss";
// import axiosInstance from "../../../../services/api/API";
// import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
// import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../Assets/icons/eye 1.svg";
import backicon from "../../../../Assets/icons/backIcon.svg";
import redirection from "../../../../Assets/icons/SalesRedirection.svg";
import Drawer from "react-modern-drawer";
// import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";
import download from "../../../../Assets/icons/download.svg";
// import DownloadSVG from "../../../../../Assets/icons/DownloadIconMIS.svg";
import moment from "moment";
import * as base64 from "base-64";
// import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
// import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
// import Loader from "../../../../customComponents/CustomLoader";
import { FiDownload } from "react-icons/fi";
import axiosInstance from "../../../services/api/API";
import CustomTable from "../../../customComponents/CustomTable";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../customComponents/CustomLoader";
import ReplacementAndRepairDetails from "./ReplacementAndRepairDetails";
import Swal from "sweetalert2";

const ReplacementAndRepair = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [jobCardList, setJobCardList] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecored] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [modelOptions, setModelOptions] = useState([]);

  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const [totalJobRecord, setTotalJobRecord] = useState(null);
  const [dealerOption, setDealerOptions] = useState([]);
  const [stageStatusVal, setStageStatusVal] = useState([]);

  const [drawerData, setDrawerData] = useState(null);

  // const [tableLoader,setTableLoader]=useState(false);
  const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
    // if (isEdit) {
    //   setIsEdit(!isEdit);
    // }
  };

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const engineer_id = localStorage.getItem("engineer_id");
  localStorage.removeItem("JobCardComplainData");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };
  const DownLoadPdf = (row) => {
    var text = row?.job_card_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}jobcardpdfreport/jobCardInvoiceDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };

  const redirectionFunc = (row) => {
    console.log(row, "RowJobCardList");
    navigate("/manage-sales/productlist/generate-order", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(row)) },
    });
  };

  useEffect(() => {
    fetchJobCardList();
  }, []);

  // useEffect(() => {
  //   console.log(filterFormData, "filteredFormData")
  // })

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload = {
      // business_partner_id: 1,
      orderBy: "job_card_id desc",
      page,
      pageSize,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      stage_name: allfilteredData?.stage_name,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      // serviceType: allfilteredData?.serviceType
      //   ? allfilteredData?.serviceType
      //   : null,
      serviceType: allfilteredData?.serviceType ?? null,
      searchText: searchTerm,
      dealer_id: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      model_id: allfilteredData?.model_id ? allfilteredData?.model_id : null,
      engineerId: engineer_id || null,
    };
    console.log(allfilteredData, "filtered Datas in payload");
    try {
      // setTableLoader(true)
      setLoading(true);
      const response = await axiosInstance.post(
        "/jobcard/replacement-return",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        // status: item?.status === 0 ? "Pending" : "Done",
        engineer_name: item.engineer_name || "--",
        rejactRemark: item.rejactRemark || "--",
        // job_card_no: onClickNavigetion(item),
        transaction_date: moment(item?.transaction_date).format("DD-MM-YYYY"),

        isApproved: item?.isApproved == 0 ? "Inactive" : "Active",
      }));
      if (response?.status == 200) {
        setJobCardList(formattedData);
        setTotalRecored(response?.data?.data?.totalRecords);
        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
        setTotalJobRecord(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    } finally {
      setLoading(false);
    }
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const Status = (item) => {
    return (
      <div
        style={{
          display: "flex",
          backgroundColor: item?.solved == 0 ? "#FEEBEB" : "#E4F7E3",
          width: 90,
          justifyContent: "center",
          paddingTop: 4,
          paddingBottom: 4,
          borderRadius: 10,
        }}
      >
        <span style={{ fontSize: 18 }}>
          {item?.solved == 0 ? "Pending" : "Done"}
        </span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("/manage-services/check-warranty/edit-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    toggleDrawer();
    console.log(rowData, "rowDataInViewButton");
    setDrawerData(rowData);
  };

  // const filteredBusinessPartners = businessPartners.filter((item) =>
  //   item.bp_name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Jobcard No.",
    "Jobcard Date",
    "Serial No.",
    "Vin No.",
    // "Warranty Type",
    // "Item Name",
    "Dealer Name",
    "Service Type",
    "Parts/Section to be Replaced/Repaired",
    "Stage Status",
    // "Status",
    "Action",
  ];
  // paid_amount
  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Serial No.": "serial_no",
    "Vin No.": "vin_no",
    "Jobcard Date": "created_at",
    // "Warranty Type":"repair_or_replacement_status",
    "Item Name": "item_name",
    "Dealer Name": "dealer_name",
    "Service Type": "repair_or_replacement_text",
    "Stage Status": "stage_name",
    // "Status":"status",
    "Parts/Section to be Replaced/Repaired": "service_type",
    "Jobcard No.": "job_card_no",
    Action: [
      // {
      //   type: "edit",
      //   icon: editIcon,
      //   label: "Edit",
      // },

      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
      {
        type: "printDeliveryNote",
        icon: download,
        label: "Print",
      },
      // {
      //   type: "redirection",
      //   icon: redirection,
      //   label: "Redirection",
      // },
    ],
  };

  // const handleClicableRow = (row) => {
  //   alert("hello")
  //   setFilterList(row);
  // };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  // useEffect(() => {
  //   fetchJobCardList();
  // }, [filters]);

  useEffect(() => {
    fetchJobCardList(0, 10);
  }, [filters, searchTerm]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    setSearchTerm("");
  };

  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  const handleSearch = () => {
    console.log(filterFormData, "filteredFormData");
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      serviceType:
        filterFormData?.serviceType === 0 || filterFormData?.serviceType === 1
          ? filterFormData?.serviceType
          : null,
      dealerId: filterFormData.dealerId || null,
      model_id: filterFormData.model_id || null,
      stage_name:
        filterFormData.stage_name !== undefined &&
        filterFormData.stage_name !== ""
          ? filterFormData.stage_name
          : null,
    });
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handelkeyDown = (event) => {
    if (event.key === "Enter") {
      fetchJobCardList({ searchText: searchTerm });
    }
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchStageStatus();
  }, []);

  const fetchStageStatus = async () => {
    try {
      const response = await axiosInstance.get(
        "/jobcard/replacement-return/stage-ddl",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.ID,
        label: dealer.NAME,
      }));

      setStageStatusVal(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-12 col-lg-3",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-12 col-lg-3",
    },
    {
      name: "stage_name",
      label: "Status",
      type: "dropdown",
      required: true,
      placeholder: "Select Complaint",
      options: stageStatusVal,
      gridClass: "col-lg-3",
    },
  ];

  if (userType === "businesspartner") {
    PhysicalStockTakingInputs.push({
      name: "serviceType",
      label: "Service Type",
      placeholder: "Select Service Type",
      type: "dropdown",
      options: [
        { label: "REPLACEMENT", value: 1 },
        { label: "REPAIR", value: 0 },
      ],
      required: true,
      gridClass: "col-12 col-lg-3",
    });
  }

  // if (userType === "businesspartner") {
  //   PhysicalStockTakingInputs.push({
  //     name: "model_id",
  //     label: "Model",
  //     placeholder: "Select Model",
  //     type: "dropdown",
  //     options: modelOptions,
  //     required: true,
  //     gridClass: "col-12 col-lg-3",
  //   });
  // }

  if (userType === "businesspartner") {
    PhysicalStockTakingInputs.push({
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    });
  }

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      // orderBy: "po_id desc",
      // page: 0,
      // pageSize: 10,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
      orderBy: "job_card_id desc",
      page: 0,
      pageSize: 10,
      dealer_id: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      model_id: allfilteredData?.model_id ? allfilteredData?.model_id : null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      stage_name: allfilteredData?.stage_name
        ? allfilteredData?.stage_name
        : "",
      serviceType: allfilteredData?.serviceType
        ? allfilteredData?.serviceType
        : 4,
    };

    try {
      const response = await axiosInstance.post(
        "/jobcard/jobCardExportExcel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important: Ensures the response is treated as a file
        },
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "JobCard_report.csv"; // Set the file name
      link.style.display = "none";

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const downloadDeliveryNote = async (rowData) => {
    try {
      const response = await axiosInstance.patch(
        `/deliveryNotesPdf/${rowData?.job_card_id}`,
        {
          dealer_id: rowData?.dealer_id,
          type_of_service: rowData?.type_of_service,
        }, // body (empty)
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // 🔥 REQUIRED
        },
      );

      // Create blob
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      // Extract filename from header (if present)
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "deliveryNote.pdf";

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        title: "Success",
        text: "Downloaded Successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error downloading PDF:", error);

      Swal.fire({
        title: "Error",
        text: "Failed to download PDF",
        icon: "error",
      });
    }
  };

  const downloadDeliveryNoteDealer = async (rowData) => {
    try {
      const response = await axiosInstance.patch(
        `/jobcard/admin/deliveryNoteDownload/${rowData?.job_card_id}`,
        {
          dealer_id: rowData?.dealer_id,
          type_of_service: rowData?.type_of_service,
          service_type: parseInt(rowData?.repair_or_replacement_status, 10),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fileUrl = response?.data?.data;

      if (fileUrl) {
        window.open(fileUrl, "_blank"); // ✅ Opens image in new tab
      } else {
        Swal.fire({
          title: "Error",
          text: "No file URL received",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error opening file:", error);

      Swal.fire({
        title: "Error",
        text: "Failed to open file",
        icon: "error",
      });
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer ">
            <div className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2">
              <div
                style={{
                  lineHeight: "1px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <p className="ServiceBreadcrumbs">
                    Services / Check Warranty
                  </p>
                </div>
                <div>
                  <h5 style={{ fontWeight: "600" }}>Service Job Card</h5>
                </div>
              </div>
            </div>
            <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
              <div className="listSideBorder" />
            </div>
          </div>
          <div className="tableWrapper">
            <div className="filterView">
              <div className="filterLeftView col-md-4 pt-4 gap-2">
                <h5 className="all-jobcard-list">Replacement and Repaired</h5>
                <div>
                  <SearchInput
                    placeholder="Search..."
                    onSearch={fetchJobCardList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
              </div>
              <div className="filterRightView col-md-8 gap-2">
                {/* <div className="mt-3">
                  <h5
                    className="job-card-filter-by"
                    style={{ paddingTop: "20px", width: "6rem" }}
                  >
                    Filter By
                  </h5>
                </div> */}

                <ListLogisticsFilters
                  formConfig={PhysicalStockTakingInputs}
                  formData={filterFormData}
                  setFormData={setFilterFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleSearch={handleSearch}
                  handleClear={clearFilter}
                  // onSubmit={handleFormSubmit}
                />
              </div>
            </div>

            <CustomTable
              data={jobCardList}
              headers={Job_Card_TABLE_HEADERS}
              keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
              onEdit={handleEdit}
              handleViewButton={handleViewButton} // Pass the handleEdit function
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              //  handleClicableRow={handleClicableRow}
              pdfDownLoad={DownLoadPdf}
              redirectionFunc={redirectionFunc}
              totalRecords={totalRecords}
              // downloadDeliveryNote={downloadDeliveryNote}
              downloadDeliveryNote={
                userType === "businesspartner"
                  ? downloadDeliveryNote
                  : downloadDeliveryNoteDealer
              }
            />
          </div>

          {isOpen && (
            <Drawer
              size={800}
              open={isOpen}
              onClose={toggleDrawer}
              direction="right"
              className="bla bla bla"
            >
              <div style={{ padding: "30px" }}>
                <div
                  style={{ paddingLeft: "46px" }}
                  className="backbutton"
                  
                >
                  <img src={backicon} alt="back" onClick={toggleDrawer} />
                  <span className="backbtntitleDetails">
                    Replacement or Repair Details
                  </span>
                </div>

                <div className="mt-3" style={{ paddingLeft: "44px" }}>
                  <ReplacementAndRepairDetails
                    drawerData={drawerData}
                    toggleDrawer={toggleDrawer}
                    fetchJobCardListRefresh={fetchJobCardList}
                  />
                </div>
                {/* <hr /> */}
              </div>
            </Drawer>
          )}
        </div>
      )}
    </div>
  );
};

export default ReplacementAndRepair;
